import { createAction, props } from '@ngrx/store';

export const loadDeviceFieldsTitles = createAction(
    '[DeviceFieldsTitles Store] Load',
    props<{ deviceFieldsTitles: any }>()
);
